import { EventsClient } from './client';
import { Cache } from './cache';
import { getAlarmModelName } from './util/getAlarmModelName';
import { parseAlarmData } from './util/parseAlarmData';
import { getPropertyId } from './util/getPropertyId';
import { COMPARISON_SYMBOL } from './constants';
import { toValue } from '../../time-series-data/util/toDataPoint';
import { getAlarmSourceProperty } from './util/getAlarmSourceProperty';
export class SiteWiseAlarmModule {
    constructor(client, siteWiseAssetModule) {
        this.client = new EventsClient(client);
        this.assetModuleSession = siteWiseAssetModule.startSession();
        this.cache = new Cache(this.client);
    }
    async getAlarmModel(name) {
        return this.cache.getAlarmModel(name);
    }
    async getAlarm({ assetId, alarmStatePropertyId, }) {
        var _a, _b, _c;
        try {
            const alarmAsset = await this.assetModuleSession.fetchAssetSummary({
                assetId,
            });
            const assetModelId = alarmAsset === null || alarmAsset === void 0 ? void 0 : alarmAsset.assetModelId;
            const assetModel = await this.assetModuleSession.fetchAssetModel({
                assetModelId: assetModelId,
            });
            const alarmSourceId = (_a = getAlarmSourceProperty(assetModel, alarmStatePropertyId)) === null || _a === void 0 ? void 0 : _a.id;
            if (!alarmSourceId) {
                return undefined;
            }
            const alarmSourcePropertyValue = await this.assetModuleSession.fetchAssetPropertyValue({
                assetId,
                propertyId: alarmSourceId,
            });
            const alarmModelName = getAlarmModelName(toValue(alarmSourcePropertyValue.value));
            const { comparisonOperator, thresholdPropertyId: thresholdPropertyIdExpression, inputPropertyId: inputPropertyIdExpression, severity, } = await this.getAlarmModel(alarmModelName);
            const alarmStatePropertyValue = await this.assetModuleSession.fetchAssetPropertyValue({
                assetId: assetId,
                propertyId: alarmStatePropertyId,
            });
            const state = parseAlarmData(toValue(alarmStatePropertyValue.value));
            const thresholdPropertyId = getPropertyId(thresholdPropertyIdExpression);
            const thresholdPropertyValue = await this.assetModuleSession.fetchAssetPropertyValue({
                assetId,
                propertyId: thresholdPropertyId,
            });
            const inputPropertyId = getPropertyId(inputPropertyIdExpression);
            const inputPropertyName = (_c = (_b = assetModel.assetModelProperties) === null || _b === void 0 ? void 0 : _b.find(({ id }) => id === inputPropertyId)) === null || _c === void 0 ? void 0 : _c.name;
            const threshold = toValue(thresholdPropertyValue.value);
            const rule = `${inputPropertyName} ${COMPARISON_SYMBOL[comparisonOperator]} ${threshold}`;
            return {
                assetId,
                alarmStatePropertyId,
                inputPropertyId,
                thresholdPropertyId,
                comparisonOperator,
                threshold,
                severity,
                rule,
                state,
            };
        }
        catch (_d) {
            return undefined;
        }
    }
}
